module.exports = __webpack_public_path__ + "img/web2icon1.31927f8e.png";